import * as React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IAction } from "../../action-editor/ActionEditor";
import { IFieldTitleProps } from "../../components/FieldTitle";
import { generateIconProp } from "../../icon-selector/IconEditor";
import classNames from "classnames";
export declare type ICardType = 'list' | 'image-carousel-1' | 'image-carousel-2' |'image-carousel-3'| 'carousel' |'custom';
export interface ICFLabel {
    text: string;
    icon: string;
    color: string;
    fontSize: string;
    backgroundColor: string;
    type: string;
}
export interface ICFButton {
    icon: string;
    onClick: IAction;
    color: string;
    backgroundColor: string;
}
export interface ICardProps  {
	
    imageField:string;
    imageType:string;
    imageBorderType:string;
    imageBackgroundColor:string;
    imageIcon:string;
    imageIconColor:string;
    imageSize:string;
    titleField:string;
    titleColor:string;
    titleSize:string;
    subTitleField:string;
    subTitleColor:string;
    subTitleSize:string;
    borderColor:string;
    topLabels:ICFLabel[];
    bottomLabels:ICFLabel[];
    buttons:ICFButton[];
    topBorder?: boolean;
    bottomBorder?: boolean;
    cardType?:ICardType;
    aspectRatio?:string;
    onClick:IAction;
 }


export const ItemCard2: React.FunctionComponent<ICardProps  & {replacer?:(x:string)=>string}> = (props) => {


    let replacer = props.replacer ||( (x)=>x);

    function makeLabel(label:ICFLabel) {
        return <div style={label.type=='pill'?{backgroundColor:label.backgroundColor}:{}} className={classNames('cf-card-label',{'pill':label.type=='pill'})}>
            <FontAwesomeIcon color={label.color} icon={generateIconProp(label.icon)} />
            <div style={{color:label.color}} className='cf-card-label-text'>{replacer(label.text)}</div>
        </div>;
    }
    function makeButton(button:ICFButton) {
        return <div className='cf-card-action-icon' style={{backgroundColor:button.backgroundColor}}>
            <FontAwesomeIcon icon={generateIconProp(button.icon)} color={button.color} />
        </div>;
    }

    let imageField = replacer(props?.imageField);
    let imageType = replacer(props?.imageType);
    let imageBorderType = replacer(props?.imageBorderType);
    let imageSize = Number(replacer(props?.imageSize))||30;
    let imageBackgroundColor = replacer(props?.imageBackgroundColor);
    let imageIcon = replacer(props?.imageIcon);
    let imageIconColor = replacer(props?.imageIconColor);
    let titleField = replacer(props?.titleField);
    let titleColor = replacer(props?.titleColor);
    let titleSize = replacer(props?.titleSize);
    let subTitleField = replacer(props?.subTitleField);
    let subTitleColor = replacer(props?.subTitleColor);
    let subTitleSize = replacer(props?.subTitleSize);
    let borderColor = replacer(props?.borderColor);
    var topLabels = props?.topLabels || [];
    var bottomLabels = props?.bottomLabels || [];
    var buttons = props?.buttons || [];
    var img = <div />;
    var borders:any = {};
    if (props.topBorder && borderColor) {
        borders['borderTop'] = `1px solid ${borderColor}`;
    }
    if (props.bottomBorder && borderColor) {
        borders['borderBottom'] = `1px solid ${borderColor}`;
    }
    if (imageType == 'icon') {
        img = <FontAwesomeIcon style={{fontSize:((Number(imageSize)-10)+'px')||'30px'}} icon={generateIconProp(imageIcon)} color={imageIconColor} />;
    } else if (imageField) {
        
        img = <div className='cf-card-image' style={{backgroundImage:`url(${imageField})`}} />;
    }

    var cardStyles:any = {};
    var imageStyles:any = {};
    var carouselAspectRatio = Number(props.aspectRatio) || 1;
    switch (props.cardType) {
        case "carousel":
            cardStyles.aspectRatio = carouselAspectRatio+'';
            break;
        case "image-carousel-1":
            cardStyles.aspectRatio = carouselAspectRatio+'';
            break;
        case "image-carousel-2":
            cardStyles.aspectRatio = carouselAspectRatio+'';
            break;
        case "image-carousel-3":
            cardStyles.aspectRatio = carouselAspectRatio+'';
            break;
        default:
            imageStyles = {width:imageSize+'px',height:imageSize+'px'}
    }
	return (
		
            <div className={'cf-card ' + props.cardType} style={{...borders,...cardStyles}}>
                <div className='cf-card-icon'>
                    <div className={classNames('cf-card-icon-wrapper',
                       imageBorderType
                    )} style={{
                        ...imageStyles,
                        backgroundColor:imageBackgroundColor,
                       
                    }} >
                        {img}
                    </div>
                </div>
                <div className='cf-card-text'>
                    <div className='cf-card-label-list cf-card-top-labels'>
                    {
                        topLabels.map(makeLabel)
                    }
                    </div>
                    <div className="cf-card-title" style={{fontSize:titleSize,color:titleColor}}>
                        {titleField}
                    </div>
                    <div className="cf-card-subtitle" style={{fontSize:subTitleSize,color:subTitleColor}}>
                        {subTitleField}
                    </div>
                    <div className='cf-card-label-list  cf-card-bottom-labels'>
                    {
                        bottomLabels.map(makeLabel)
                    } 
                    </div>
                </div>
                <div className='cf-card-buttons'>
                    {
                        buttons.map(makeButton)
                    }
                </div>
            </div>
	)
}
